import { requestApi } from '../util/network'

/**
 * 代收点退出
 */
export const chainLogout =
    () =>
      requestApi(
        '/chain_manage/logout',
        'POST',
        {
          'client_type': 'wap'
        },
        'chain'
      )

/**
 * 代收点修改密码
 */
export const chainChangePassword =
    (data) =>
      requestApi(
        '/chain_manage/change_password',
        'POST',
        data,
        'chain'
      )
/**
 * 代收点订单
 */
export const getChainOrderList =
    (parmas, order_sn, state_type) =>
      requestApi(
        '/chain_order/get_order_list',
        'POST',
        {
          'order_sn': order_sn,
          'state_type': state_type,
          'page': parmas.page,
          'per_page': parmas.per_page
        },
        'chain'
      )
// 获取订单信息
export const getChainOrderInfo =
    (orderId) =>
      requestApi(
        '/chain_order/order_info',
        'POST',
        {
          'chain_order_id': orderId
        },
        'chain'
      )

/**
 * 取件通知
 */
export const chainArrive =
    (orderId) =>
      requestApi(
        '/chain_order/arrive_point',
        'POST',
        {
          'chain_order_id': orderId
        },
        'chain'
      )
/**
 * 提货验证
 */
export const chainPickup =
    (orderId, pickupCode) =>
      requestApi(
        '/chain_order/pickup_parcel',
        'POST',
        {
          'chain_order_id': orderId,
          'pickup_code': pickupCode
        },
        'chain'
      )
/**
 * 物流跟踪
 */
export const chainExpress =
    (orderId) =>
      requestApi(
        '/chain_order/search_deliver',
        'POST',
        {
          'chain_order_id': orderId
        },
        'chain'
      )
/**
 * 代收点信息
 */
export const chainInformation =
    () =>
      requestApi(
        '/chain_manage/information',
        'POST',
        {},
        'chain'
      )
/**
 * 代收点设置
 */
export const chainSetting =
    (data) =>
      requestApi(
        '/chain_manage/setting',
        'POST',
        data,
        'chain'
      )
/**
 * 代收点重新申请
 */
export const chainApplyAgain =
    (data) =>
      requestApi(
        '/chain_manage/apply_again',
        'POST',
        data,
        'chain'
      )

// 获取卖家商品列表
export const getGoodsList =
    (params, keyword, goods_type, search_type) =>
      requestApi(
        '/chain_goods/goods_list',
        'POST',
        {
          'keyword': keyword,
          'goods_type': goods_type,
          'search_type': search_type,
          'page': params.page,
          'per_page': params.per_page,
          'client_type': 'wap'
        },
        'chain'
      )

// 商品编辑
export const goodsEdit =
    (commonid) =>
      requestApi(
        '/chain_goods/edit_goods',
        'POST',
        {
          'commonid': commonid
        },
        'chain'
      )

// 获取店铺商品分类公共数据
export const getCommonData =
    (class_id) =>
      requestApi(
        '/chain_goods/get_common_data',
        'POST',
        {
          'class_id': class_id
        },
        'chain'
      )

// 商品保存
export const goodsSave =
    (data) =>
      requestApi(
        '/chain_goods/save_goods',
        'POST',
        data,
        'chain'
      )
